import {
  Button,
  DatePicker,
  Drawer,
  Form,
  Input,
  InputNumber,
  Select,
  Space,
  Switch,
} from 'antd';
import dayjs from 'dayjs';
import { useState } from 'react';
import {
  AOS_VALIDATION_MESSAGES,
  POD_ROLES,
} from '../../../../common/constants';
import CommonSelect from '../../../../components/CommonSelect';
import { USERS } from '../graphql/Queries';

function MemberDrawer({ form, open, editMember, loading, onFinish, onClose }) {
  const [userSearch, setUserSearch] = useState('');

  return (
    <Drawer
      title={editMember ? 'Edit Assignment' : 'Add Member'}
      open={open}
      onClose={onClose}
      width={420}
      afterOpenChange={(drawerOpen) => {
        if (!drawerOpen) {
          form.resetFields();
          setUserSearch('');
        }
      }}
    >
      <Form form={form} layout="vertical" onFinish={onFinish}>
        {!editMember && (
          <>
            <Form.Item
              name="employeeId"
              label="Employee"
              rules={[
                {
                  required: true,
                  message: AOS_VALIDATION_MESSAGES.EMPLOYEE_REQUIRED,
                },
              ]}
            >
              <CommonSelect
                placeholder="Select Employee"
                showSearch
                allowClear
                query={USERS}
                responsePath="users.users"
                valuePath="id"
                labelPath="displayName"
                conditionToCheckBeforeQuery={open}
                onSearch={setUserSearch}
                variables={{
                  filters: {
                    searchStrings: userSearch ? [userSearch] : [],
                  },
                }}
                useEffectDeps={[userSearch, open]}
              />
            </Form.Item>
            <Form.Item
              name="podRole"
              label="Role"
              rules={[
                {
                  required: true,
                  message: AOS_VALIDATION_MESSAGES.POD_ROLE_REQUIRED,
                },
              ]}
            >
              <Select placeholder="Select Role" options={POD_ROLES} />
            </Form.Item>
            <Form.Item
              name="startDate"
              label="Start Date"
              rules={[
                {
                  required: true,
                  message: AOS_VALIDATION_MESSAGES.START_DATE_REQUIRED,
                },
              ]}
            >
              <DatePicker
                style={{ width: '100%' }}
                placeholder="Select Start Date"
              />
            </Form.Item>
          </>
        )}
        <Form.Item
          name="allocationPct"
          label="Allocation %"
          rules={[
            {
              required: true,
              message: AOS_VALIDATION_MESSAGES.ALLOCATION_REQUIRED,
            },
          ]}
        >
          <InputNumber
            min={1}
            max={100}
            style={{ width: '100%' }}
            placeholder="Enter allocation percentage"
          />
        </Form.Item>
        <Form.Item
          name="isPrimary"
          label="Primary Assignment"
          valuePropName="checked"
          initialValue
        >
          <Switch />
        </Form.Item>
        {editMember && (
          <Form.Item name="endDate" label="End Date">
            <DatePicker
              style={{ width: '100%' }}
              placeholder="Select End Date"
              disabledDate={(current) =>
                editMember.startDate &&
                current &&
                current <= dayjs(editMember.startDate).endOf('day')
              }
            />
          </Form.Item>
        )}
        <Form.Item name="changeReason" label="Change Reason">
          <Input.TextArea rows={2} placeholder="Enter change reason" />
        </Form.Item>
        <Form.Item>
          <Space>
            <Button type="primary" htmlType="submit" loading={loading}>
              {editMember ? 'Save' : 'Assign'}
            </Button>
            <Button onClick={onClose}>Cancel</Button>
          </Space>
        </Form.Item>
      </Form>
    </Drawer>
  );
}

export default MemberDrawer;
